import { lazy } from "react";

export const Header = lazy(() => import("#app/interface/cabinet/header/Header"));
export const AuthLayout = lazy(() => import("./AuthLayout/AuthLayout"));
export const Phone = lazy(() => import("#app/interface/cabinet/phone/Phone"));
export const CalendarPage = lazy(async () => {
    const module = await import("#app/pages/Calendar/CalendarPage");
    return { default: module.default };
});
export const CalendarFilter = lazy(async () => {
    const module = await import("#app/components/Calendar/CalendarFilter/CalendarFilter");
    return { default: module.default };
});
export const ApplicationPage = lazy(async () => {
    const module = await import("#app/pages/Application/ApplicationPage");
    return { default: module.default };
});
export const ClientsPage = lazy(() => import("#app/pages/Clients/ClientsPage"));
export const Common = lazy(() => import("#app/pages/Config/Common"));
export const Cabinet = lazy(() => import("#app/pages/Cabinet/Cabinet"));
export const FunnelPage = lazy(() => import("#app/pages/Funnel/FunnelPage"));
export const Hierarchy = lazy(() => import("#app/pages/Hierarchy/Hierarchy"));
export const Learn = lazy(() => import("#app/pages/Learn/Learn"));
export const LearnAton = lazy(() => import("#app/pages/Learn/LearnAton"));
export const EventTranscription = lazy(
    () => import("#app/pages/EventTranscription/EventTranscription")
);
export const UnexpectedError = lazy(() => import("#app/interface/error/UnexpectedError"));
export const TestPage = lazy(() => import("#app/pages/Test/TestPage"));
